import { faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo } from 'react'
import { useTheme } from '../../../../theme/hooks'

type Props = {
  effectiveUploading: boolean
  isQueueFull: boolean
  maxQueue: number
  onCancel: () => void
  onClose: () => void
  onSubmit: () => void
}

const FooterBase = ({
  effectiveUploading,
  isQueueFull,
  maxQueue,
  onCancel,
  onClose,
  onSubmit,
}: Props) => {
  const { theme } = useTheme()

  return (
    <div
      className="sticky bottom-0 z-10 flex flex-wrap items-center justify-between gap-3 px-8 py-4"
      style={{
        borderTop: `1px solid ${theme.section.border}`,
        backgroundColor: theme.surface.primary,
      }}
    >
      {effectiveUploading && (
        <span className="text-xs" style={{ color: theme.text.secondary }}>
          Vous pouvez fermer cette fenêtre, le traitement continue en
          arrière-plan.
        </span>
      )}
      <div className="ml-auto flex flex-wrap items-center gap-2">
        {effectiveUploading && (
          <button
            onClick={onCancel}
            className="rounded-lg border px-4 py-2 text-sm font-medium transition-colors"
            style={{
              borderColor: theme.status.error.border,
              color: theme.status.error.text,
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = theme.status.error.bg
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent'
            }}
          >
            Annuler l&apos;import
          </button>
        )}
        <button
          onClick={onClose}
          className="rounded-lg px-4 py-2 text-sm font-medium transition-colors"
          style={{
            backgroundColor: theme.button.secondary.bg,
            color: theme.button.secondary.text,
          }}
          onMouseEnter={e => {
            e.currentTarget.style.backgroundColor =
              theme.button.secondary.bgHover
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = theme.button.secondary.bg
          }}
        >
          Fermer
        </button>
        <button
          onClick={onSubmit}
          disabled={isQueueFull}
          className="flex items-center rounded-lg px-4 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed"
          style={{
            backgroundColor: isQueueFull
              ? theme.button.disabled.bg
              : theme.button.primary.bg,
            color: isQueueFull
              ? theme.button.disabled.text
              : theme.button.primary.text,
            opacity: isQueueFull ? 0.6 : 1,
          }}
          onMouseEnter={e => {
            if (!isQueueFull) {
              e.currentTarget.style.backgroundColor =
                theme.button.primary.bgHover
            }
          }}
          onMouseLeave={e => {
            if (!isQueueFull) {
              e.currentTarget.style.backgroundColor = theme.button.primary.bg
            }
          }}
          title={
            isQueueFull
              ? `File d'attente pleine (max ${maxQueue}).`
              : undefined
          }
        >
          <FontAwesomeIcon icon={faFileUpload} className="mr-2 h-4 w-4" />
          Importer
        </button>
      </div>
    </div>
  )
}

export const Footer = memo(FooterBase)
